import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowRight, Camera, LockKeyhole } from "lucide-react";

const APP_URL = "https://fotos.geauxfotos.com";
const EDITORIAL_FONT = "'Cormorant Garamond', Georgia, serif";
const READY = process.env.REACT_APP_GEAUXFRAME_READY === "true";

export default function GalleryHub() {
  return <main className="gallery-page min-h-screen bg-[#080808] px-6 py-14 text-[#f5f0e8] sm:px-10">
    <Seo title="Event Galleries | Fotos on the Geaux" description="Find your Fotos on the Geaux event photos in GeauxFrame." path="/gallery" />
    <div className="mx-auto max-w-5xl">
      <nav className="flex items-center justify-between border-b border-white/15 pb-5 font-accent text-[10px] tracking-[.2em]">
        <Link to="/">FOTOS ON THE GEAUX</Link><Link to="/">BACK TO SITE</Link>
      </nav>
      <div className="max-w-3xl py-20 sm:py-28">
        <p className="max-w-full font-accent text-[11px] tracking-[.22em] text-[#b99870] sm:text-xs sm:tracking-[.3em]">GEAUXFRAME · EVENT GALLERIES</p>
        <h1 className="mt-7 text-[clamp(3.2rem,11.4vw,8rem)] font-medium leading-[.86] tracking-[-.055em]" style={{ fontFamily: EDITORIAL_FONT }}><span className="block">The night</span><span className="block italic text-[#d5b88f]">in your hands.</span></h1>
        <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/65">Your event photos live here. Find your shots, save your favorites and take a piece of the night home.</p>
      </div>
      <section className="grid gap-5 border-t border-white/15 py-10 sm:grid-cols-2">
        <article className="border border-white/15 bg-[#121212] p-8">
          <Camera className="text-[#b99870]" aria-hidden="true" />
          <p className="mt-8 font-accent text-xs tracking-[.25em] text-[#b99870]">FEATURED EVENT</p>
          <h2 className="mt-3 text-5xl font-medium leading-[.95] tracking-[-.035em] sm:text-6xl" style={{ fontFamily: EDITORIAL_FONT }}>Pole & Polaroids</h2>
          <p className="mt-3 text-sm leading-6 text-white/55">September 25, 2026 · NOLA Pole. Digital photos are reviewed before they appear in the guest gallery.</p>
          {READY ? <a href={APP_URL + "/e/pole-polaroids"} className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#f5f0e8] px-5 py-3 font-accent text-xs tracking-[.15em] text-black">FIND MY PHOTOS <ArrowRight size={15} /></a>
            : <p className="mt-8 text-sm text-[#b99870]">Gallery opens after the event.</p>}
        </article>
        <article className="border border-white/15 bg-[#121212] p-8">
          <LockKeyhole className="text-[#b99870]" aria-hidden="true" />
          <p className="mt-8 font-accent text-xs tracking-[.25em] text-[#b99870]">PRIVATE EVENTS</p>
          <h2 className="mt-3 text-5xl font-medium leading-[.95] tracking-[-.035em] sm:text-6xl" style={{ fontFamily: EDITORIAL_FONT }}>Have a gallery link?</h2>
          <p className="mt-3 text-sm leading-6 text-white/55">Use the QR code or event link your photographer shared. Some galleries require an event password.</p>
          {READY && <a href={APP_URL} className="mt-8 inline-flex items-center gap-3 border-b border-[#b99870] pb-2 font-accent text-xs tracking-[.15em]">OPEN GEAUXFRAME <ArrowRight size={15} /></a>}
        </article>
      </section>
    </div>
  </main>;
}

